import ThreeDotsHorizontalIcon from "@redotech/redo-icons/dots-horizontal.svg";
import LinkExternalIcon from "@redotech/redo-icons/link-external-02.svg";
import MarkerPinIcon from "@redotech/redo-icons/marker-pin-01.svg";
import PencilIcon from "@redotech/redo-icons/pencil-01.svg";
import SkipForwardIcon from "@redotech/redo-icons/skip-forward.svg";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { SubscriptionIntegration } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { memo, useState } from "react";

interface SubscriptionActionsDropdownProps {
  subscription: SubscriptionIntegration;
  onEdit: (subscription: SubscriptionIntegration) => void;
  onEditAddress: (subscription: SubscriptionIntegration) => void;
  onSkip: (subscription: SubscriptionIntegration) => void;
  onCancel: (subscription: SubscriptionIntegration) => void;
  onViewInRecharge: (subscriptionId: number) => void;
}

export const SubscriptionActionsDropdown = memo(
  function SubscriptionActionsDropdown({
    subscription,
    onEdit,
    onEditAddress,
    onSkip,
    onCancel,
    onViewInRecharge,
  }: SubscriptionActionsDropdownProps) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);

    const actionItems: RedoListItem<string>[] = [
      {
        type: "text",
        id: "edit",
        value: "edit",
        text: "Edit subscription",
        leadingItem: { type: "icon", Icon: PencilIcon },
      },
      {
        type: "text",
        id: "edit-address",
        value: "edit-address",
        text: "Edit address",
        leadingItem: { type: "icon", Icon: MarkerPinIcon },
      },
      {
        type: "text",
        id: "skip",
        value: "skip",
        text: "Skip subscription",
        leadingItem: { type: "icon", Icon: SkipForwardIcon },
      },
      {
        type: "text",
        id: "cancel",
        value: "cancel",
        text: "Cancel subscription",
        leadingItem: { type: "icon", Icon: XCloseIcon },
      },
      {
        type: "text",
        id: "view-in-recharge",
        value: "view-in-recharge",
        text: "View in Recharge",
        leadingItem: { type: "icon", Icon: LinkExternalIcon },
      },
    ];

    return (
      <>
        <RedoButton
          hierarchy="tertiary"
          IconLeading={ThreeDotsHorizontalIcon}
          onClick={() => setDropdownOpen(true)}
          ref={setButtonRef}
          size="xs"
        />
        <RedoListDropdown
          dropdownAnchor={buttonRef}
          dropdownOpen={dropdownOpen}
          items={actionItems}
          itemSelected={({ item }) => {
            switch (item.id) {
              case "edit": {
                onEdit(subscription);

                break;
              }
              case "edit-address": {
                onEditAddress(subscription);

                break;
              }
              case "skip": {
                onSkip(subscription);

                break;
              }
              case "cancel": {
                onCancel(subscription);

                break;
              }
              case "view-in-recharge": {
                onViewInRecharge(subscription.id);

                break;
              }
              // No default
            }
          }}
          setDropdownOpen={setDropdownOpen}
          size="xs"
        />
      </>
    );
  },
);
